
const state = {
  show: false,
  versionInfo: {}
}

const actions = {
  updateVersion (ctx, item) {
    ctx.commit('updateVersion', item)
  }
}

const mutations = {
  updateVersion (state, item) {
    state.versionInfo = item
  },
  showAddVersion (state, item) {
    state.show = item
  }
}

export default{
  namespaced: true,
  state,
  actions,
  mutations
}
